import { isFlagField } from 'src/graphql/entities/custom-view/custom-view-config/operators';
import {
  CustomValueSelector,
  CustomValueSelectorProps,
} from 'src/pages/Settings/rules/rules-form-ui-controls';

// rules keep the whole field object in `field` (typed as a string by react-querybuilder),
// so query-builder's `fieldData` lookup misses it and the field itself is checked instead
export const CustomViewOperatorSelector = (props: CustomValueSelectorProps) =>
  isFlagField(props.field) ? null : <CustomValueSelector {...props} />;
